module.exports = __webpack_public_path__ + "img/jieshui.0d293a15.svg";